module.exports = __webpack_public_path__ + "img/globe-text.42343a99.png";